function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classNames from 'classnames';
import T from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSearchParam } from 'react-use';
import { Wizard } from 'react-use-wizard';
import BreadcrumbStep from '../../../components/wizard/BreadcrumbStep';
import Breadcrumbs from '../../../components/wizard/Breadcrumbs';
import { MEMBERSHIP } from '../../../constants/membership';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { setMembershipPriceId, setPaymentMethodId } from '../../../redux/actions/order';
import { profileSelectors } from '../../../redux/selectors/profile';
import text from '../../../text';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff, isUserGovernment, isUserUnderTrial, userHasValidMembership } from '../../../utilities/user';
import ConfirmationStep from './ConfirmationStep';
import MembershipStep from './MembershipStep';
import OrderWizardPaymentMethod from './OrderWizardPaymentMethod';
import ProjectDetailsStep from './ProjectDetailsStep';
var getStartingStep = function(step, steps) {
    var startingStep = 1;
    if (step < steps.length) {
        startingStep = typeof step === 'string' ? !isNaN(+step) && +step : step;
    }
    return startingStep;
};
var RedirectBack = function() {
    var history = useHistory();
    useEffect(function() {
        history.goBack();
    }, [
        history
    ]);
    return null;
};
var OrderWizard = function(param) {
    var _param_isOnlyBreadcrumbs = param.isOnlyBreadcrumbs, isOnlyBreadcrumbs = _param_isOnlyBreadcrumbs === void 0 ? false : _param_isOnlyBreadcrumbs, _param_defaultStep = param.defaultStep, defaultStep = _param_defaultStep === void 0 ? 1 : _param_defaultStep, _param_isVisible = param.isVisible, isVisible = _param_isVisible === void 0 ? true : _param_isVisible;
    var _job_project, _job_project1;
    var initialStep = useSearchParam('step');
    var isBreakpointEnabled = useBreakpoint([
        'xs',
        'sm'
    ]);
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return {
            job: state.jobsReducer.job,
            membershipPriceId: state.order.membershipPriceId,
            paymentMethodId: state.order.paymentMethodId,
            currentUser: state.profileReducer.userProfile
        };
    }), job = _useSelector.job, paymentMethodId = _useSelector.paymentMethodId, currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId;
    var hasValidMembership = useSelector(profileSelectors.hasValidMembership);
    useEffect(function() {
        if (currentUser && isStaff(currentUser.role) || userHasValidMembership(currentUser) && !isUserUnderTrial(currentUser)) {
            dispatch(setMembershipPriceId(MEMBERSHIP.NO_MEMBERSHIP));
        }
    }, [
        currentUser,
        dispatch
    ]);
    // TODO: RE-IMPLEMENT
    // const isRequestQuote = useMemo(
    //   () => buyNowData.length === 0 && !isMembershipPriceId(membershipPriceId),
    //   [buyNowData.length, membershipPriceId]
    // );
    if (!job) {
        return null;
    }
    var handlePreviousStepClicked = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(previousStep) {
            return _ts_generator(this, function(_state) {
                previousStep();
                return [
                    2
                ];
            });
        });
        return function handlePreviousStepClicked(previousStep) {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: Should we move this to PaymentProvider??
    var orderSteps = [
        {
            component: /*#__PURE__*/ React.createElement(RedirectBack, null),
            name: text('cart')
        },
        {
            component: /*#__PURE__*/ React.createElement(MembershipStep, {
                nextButtonProps: {
                    label: text(isBreakpointEnabled ? 'continue' : 'continueProjectDetails')
                },
                membershipPriceId: membershipPriceId,
                onMembershipChange: function(membershipPriceIdValue) {
                    var _membershipPriceIdValue_target, _membershipPriceIdValue_target1;
                    return dispatch(setMembershipPriceId(((_membershipPriceIdValue_target = membershipPriceIdValue.target) === null || _membershipPriceIdValue_target === void 0 ? void 0 : _membershipPriceIdValue_target.value) ? (_membershipPriceIdValue_target1 = membershipPriceIdValue.target) === null || _membershipPriceIdValue_target1 === void 0 ? void 0 : _membershipPriceIdValue_target1.value : membershipPriceIdValue));
                },
                previousButtonProps: {
                    onClick: handlePreviousStepClicked
                }
            }),
            name: text('member'),
            filter: function() {
                return !process.env.DISABLE_STRIPE && !isUserGovernment(currentUser) && !isStaff(currentUser.role) && (!hasValidMembership || isUserUnderTrial(currentUser));
            }
        },
        {
            component: /*#__PURE__*/ React.createElement(ProjectDetailsStep, null),
            name: text('projectDetails')
        },
        {
            component: /*#__PURE__*/ React.createElement(OrderWizardPaymentMethod, {
                paymentMethodId: paymentMethodId,
                setPaymentMethodId: function(paymentMethodId) {
                    return dispatch(setPaymentMethodId(paymentMethodId));
                }
            }),
            name: text('paymentMethod'),
            filter: function() {
                return !isStaff(currentUser.role) && (isJobPayable(job) || isMembershipPriceId(membershipPriceId));
            },
            disabled: !(job === null || job === void 0 ? void 0 : (_job_project = job.project) === null || _job_project === void 0 ? void 0 : _job_project.name)
        },
        {
            component: /*#__PURE__*/ React.createElement(ConfirmationStep, {
                paymentMethodId: paymentMethodId,
                membershipPriceId: membershipPriceId
            }),
            name: text('confirmation'),
            disabled: !(job === null || job === void 0 ? void 0 : (_job_project1 = job.project) === null || _job_project1 === void 0 ? void 0 : _job_project1.name) && !paymentMethodId
        }
    ];
    var availableSteps = orderSteps.filter(function(step) {
        return step.filter ? step.filter() : true;
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('OrderWizard', isVisible && 'visible')
    }, /*#__PURE__*/ React.createElement(Wizard, {
        startIndex: getStartingStep(initialStep !== null && initialStep !== void 0 ? initialStep : defaultStep, availableSteps),
        header: /*#__PURE__*/ React.createElement(Breadcrumbs, null, availableSteps.map(function(param, index) {
            var name = param.name, disabled = param.disabled;
            return /*#__PURE__*/ React.createElement(BreadcrumbStep, {
                key: index,
                stepIndex: index,
                stepLabel: index + 1,
                name: name,
                disabled: disabled || isOnlyBreadcrumbs
            });
        }))
    }, availableSteps.map(function(param, index) {
        var component = param.component;
        return /*#__PURE__*/ React.createElement(Fragment, {
            key: index
        }, !isOnlyBreadcrumbs && component);
    })));
};
OrderWizard.propTypes = {
    isOnlyBreadcrumbs: T.bool,
    defaultStep: T.number,
    isVisible: T.bool
};
export default OrderWizard;
